import { useLanguage } from "@/context/AppContext";

export default function Story() {
  const { t } = useLanguage();
  return (
    <section id="story" className="section story" data-testid="story-section">
      <div className="section-label">{t.story.label}</div>
      <div className="two-col">
        <div>
          <h2 data-testid="story-section-title">
            {t.story.l1}
            <br />
            <em>{t.story.l2}</em>
          </h2>
        </div>
        <div>
          <p>{t.story.p1}</p>
          <p>{t.story.p2}</p>
          <a className="text-link" href="#legacy" data-testid="story-read-more-trigger">
            {t.story.link}
          </a>
        </div>
      </div>
    </section>
  );
}
